import {
    CONFIRMED_GET_ROLES,
    CONFIRMED_ADD_ROLE,
    CONFIRMED_EDIT_ROLE,
    CONFIRMED_DELETE_ROLE,
    CONFIRMED_GET_MODULE_LIST

} from "../actions/RoleType";

const initialState = {
    roles: [],
    modules: [],
    loading: false, 
};

export default function RoleReducer(state = initialState, action) {
    if (action.type === CONFIRMED_GET_ROLES) {
        return {
            ...state,
            loading: false,
            roles: action.payload,
        };
    }

    if (action.type === CONFIRMED_ADD_ROLE) {
        const roles = [...state.roles];
        roles.push(action.payload);
        return {
            ...state,
            roles,
        };
    }

    if (action.type === CONFIRMED_EDIT_ROLE) {
        const roles = [...state.roles];
        const index = roles.findIndex(
            (role) => role.role_id === action.payload.role_id
        );

        if (index !== -1) {
            roles[index] = action.payload;
        }

        return {
            ...state,
            roles,
        };
    }

    if (action.type === CONFIRMED_DELETE_ROLE) {
        const roles = state.roles.filter(
            (role) => role.role_id !== action.payload.role_id
        );

        return {
            ...state,
            roles,
        };
    }

    if (action.type === CONFIRMED_GET_MODULE_LIST) {
        return {
            ...state,
            modules: action.payload,
        };
    }

    return state;
}
